var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoteMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 13 13",
    width: 11,
    height: 11,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-preferred-contact",
    transform: "translate(-462.000000, -587.000000)",
    fill: "#5C6268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-note-method",
    transform: "translate(462.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C10.1045695,-2.02906125e-16 11,0.8954305 11,2 L11,9 C11,10.1045695 10.1045695,11 9,11 L2,11 C0.8954305,11 1.3527075e-16,10.1045695 0,9 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L9,0 Z M5,6 L3,6 C2.44771525,6 2,6.44771525 2,7 C2,7.55228475 2.44771525,8 3,8 L3,8 L5,8 C5.55228475,8 6,7.55228475 6,7 C6,6.44771525 5.55228475,6 5,6 L5,6 Z M7,3 L3,3 C2.44771525,3 2,3.44771525 2,4 C2,4.55228475 2.44771525,5 3,5 L3,5 L7,5 C7.55228475,5 8,4.55228475 8,4 C8,3.44771525 7.55228475,3 7,3 L7,3 Z",
    vectorEffect: "non-scaling-stroke"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoteMethod);
export default __webpack_public_path__ + "static/media/icon-note-method.1b409a2a667cf26200fdefa0499868c6.svg";
export { ForwardRef as ReactComponent };